import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { useDebouncedSearch } from 'modules/core/hooks/useSearch'

import { useFinancialWorkspace } from 'modules/finance/components/FinancialWorkspace/Providers/Provider'
import { UseAdditionalFilters } from 'modules/finance/components/FinancialWorkspace/types/filter'
import { InsightTableGroupBy } from 'modules/finance/components/FinancialWorkspace/types/table'
import 'modules/finance/components/FinancialWorkspacePayroll/components/Table/const'

import { ExportButton } from './components/ExportButton'
import { GroupBy } from './components/GroupBy'
import { SearchButton } from './components/SearchButton'
import PaginatedTable from './table'
import { CustomizableTableProps } from './types'
import { useTotal } from 'modules/finance/components/FinancialWorkspace/Providers/TotalProvider/index'

interface Props {
  tableProps: CustomizableTableProps
  defaultGroupBy: InsightTableGroupBy
  useAdditionalFilters?: UseAdditionalFilters
}

export const Table = ({ tableProps, defaultGroupBy, useAdditionalFilters }: Props) => {
  const [group, setGroup] = useState<InsightTableGroupBy | undefined>()
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()
  const { tableIsEmpty, setTableIsEmpty, setTableIsLoading } = useTotal()

  const { formattedState } = useFinancialWorkspace()

  const {
    type,
    hideSearch,
    useOnExport,
    headerTitle,
    useDataFetch,
    titleResolver,
    emptyStateProps,
  } = tableProps

  const { filtersApplied: customFiltersApplied, filterTracker: customFilterTracker } =
    useAdditionalFilters?.() || {}

  const onExport = useOnExport?.({ ...formattedState, groupBy: group || defaultGroupBy })?.onExport

  if (!useDataFetch) return null

  return (
    <Box paddingTop="s16">
      <Box
        borderRadius={tableIsEmpty ? undefined : { all: 'abs016' }}
        border={
          tableIsEmpty ? undefined : { all: { color: 'grey400', width: 's1', style: 'solid' } }
        }
      >
        {!tableIsEmpty && (
          <Box flexDirection="row" justifyContent="spaceBetween" gap="s8" padding="s12">
            <Box flexDirection="row" gap="s8" alignItems="center">
              <GroupBy group={group} setGroup={setGroup} tableProps={tableProps} />
              {headerTitle && headerTitle}
            </Box>

            <Box flexDirection="row" gap="s8">
              {!hideSearch?.(group) && <SearchButton search={search || ''} onSearch={onSearch} />}

              {onExport && <ExportButton onExport={onExport} />}
            </Box>
          </Box>
        )}

        <PaginatedTable
          type={type}
          search={debouncedSearch}
          useDataFetch={useDataFetch}
          setIsEmpty={setTableIsEmpty}
          title={titleResolver(group)}
          group={group || defaultGroupBy}
          defaultGroupBy={defaultGroupBy}
          formattedState={formattedState}
          setIsLoading={setTableIsLoading}
          emptyStateProps={emptyStateProps}
          customFilterTracker={customFilterTracker}
          customFiltersApplied={customFiltersApplied}
        />
      </Box>
    </Box>
  )
}
